const organisationSettingConstants = {
  GET_ORG_SETTING_SUCCESS: " GET_ORG_SETTING_SUCCESS",
  GET_ORG_SETTING_FAILURE: "GET_ORG_SETTING_FAILURE",
  UPDATE_ORG_SETTING_SUCCESS: " UPDATE_ORG_SETTING_SUCCESS",
  UPDATE_ORG_SETTING_FAILURE: "UPDATE_ORG_SETTING_FAILURE",
  ADD_ORG_DATA_SETTING_SUCCESS: " ADD_ORG_DATA_SETTING_SUCCESS",
  ADD_ORG_DATA_SETTING_FAILURE: "ADD_ORG_DATA_SETTING_FAILURE",
  PARITAL_DEL_ORG_SETTING_SUCCESS: " PARITAL_DEL_ORG_SETTING_SUCCESS",
  PARITAL_DEL_ORG_SETTING_FAILURE: "PARITAL_DEL_ORG_SETTING_FAILURE",
  FULL_DEL_ORG_SETTING_SUCCESS: " FULL_DEL_ORG_SETTING_SUCCESS",
  FULL_DEL_ORG_SETTING_FAILURE: "FULL_DEL_ORG_SETTING_FAILURE",
};

export default organisationSettingConstants;
